function toggleHeaderNav() {
  const btn = document.getElementById('js-header-nav-btn');
  if (!btn) return;
  const nav = document.getElementById('js-header-nav');
  btn.addEventListener('click', function () {
    btn.classList.toggle('is-open');
    nav.classList.toggle('is-active');
  });
}
export { toggleHeaderNav };
